import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Cross-origin <img>/<script> failures (e.g. a Google Drive image loaded with
// crossOrigin that has no CORS headers) surface to window.onerror as a
// detail-less "Script error." They are ALREADY handled at the element level
// (img.onerror → fallback) and carry zero actionable info, but in dev they
// trip the CRA red error overlay. Swallow only that exact masked error.
window.addEventListener(
  "error",
  (e) => {
    if (e && e.message === "Script error." && !e.filename) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true // capture phase — run before the dev overlay's listener
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
